<!-- eslint-disable no-debugger -->
<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<div class="mainList">
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px;padding: 5px 0">
				<el-form-item
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value
					"
				>
          <InputTopTip v-model="selectedOptions" :placeholder="querylist">
            <el-cascader
              :key="refreshItem"
              ref="cascaderArr"
              placeholder=""
              v-model="selectedOptions"
              size="small"
              :options="options"
              :props="{
                value: 'id',
                label: 'name',
                children: 'child',
                expandTrigger: 'click',
                emitPath: false
              }"
              @change="handleChange($event)"
            >
            </el-cascader>
          </InputTopTip>
				</el-form-item>
				<el-form-item
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value
					"
				>
          <InputTopTip v-model="filter_form.name" placeholder="学校名字">
            <el-input
              style="width: 220px;"
              placeholder=""
              @keyup.native.enter="refreshDataListBefore()"
              v-model="filter_form.name"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
						$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
					"
				>
          <InputTopTip v-model="filter_form.username" placeholder="教师名字">
            <el-input
              style="width: 220px;"
              placeholder=""
              @keyup.native.enter="refreshDataListBefore()"
              v-model="filter_form.username"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="SearchGrade" placeholder="年级" v-if="
            $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
            $store.state.user.userInfo.type === $api.account.types.OTHER.value
          ">
            <el-select
              ref="SearchGrade"
              v-model="SearchGrade"
              style="width: 100px;"
              placeholder=""
              size="small"
              @change="SearchGradeChange"
            >
              <el-option v-for="d in gradesArr" :key="d.val" :label="d.name" :value="d.val" />
            </el-select>
          </InputTopTip>
          <InputTopTip v-model="SearchGrade" placeholder="年级" v-else>
            <el-select
              ref="SearchGrade"
              v-model="SearchGrade"
              placeholder=""
              style="width: 100px;"
              size="small"
              @change="SearchGradeChange"
            >
              <el-option v-for="d in teacherGradesArr" :key="d.val" :label="d.name" :value="d.val" />
            </el-select>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="SearchClass" placeholder="班级">
            <el-select
              ref="SearchClass"
              style="width: 100px;"
              v-model="SearchClass"
              placeholder=""
              size="small"
              @change="SearchClassChange"
            >
              <el-option v-for="item in classNumber" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

        <el-form-item>
          <InputTopTip v-model="fb_state" placeholder="班级状态">
            <el-select
              ref="SearchClass"
              style="width: 120px;"
              v-model="fb_state"
              placeholder=""
              size="small"
              @change="refreshDataListBefore()"
            >
              <el-option v-for="item in classStatus" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click="refreshDataListBefore"
						>搜索</el-button
					>
					<el-button
						type="primary"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div class="list-area-otis" v-if="$permissions([SP22001, SP22002, SP22006, SP22007, SP22005])">
					<template>
						<div style="display: flex; padding-left: 18px;">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px;"
								@click="Newbuttont"
								v-permission="SP22001"
								>新建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-download"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="$refs.importDialog.dialogVisible = true"
								v-permission="SP22002"
								>批量创建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-connection"
								:disabled="multipleSelection.length === 0"
								@click="RelatedReTacher"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								v-if="$store.state.user.userInfo.type !== $api.account.types.TEACHER.value"
								v-permission="SP22006"
								>关联老师</el-button
							>
              <el-button
								size="small"
								@click="downloadClassStudent"
                :class="[multipleSelection.length === 0 ? 'box' : 'box2', 'button-img']"
                :disabled="multipleSelection.length === 0"
								v-if="
                  $store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
                  $store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
                ">
                  <img :src="require('@/assets/image/down1.3.1.png')" _w="15px" _m="r-5px">
                  下载学生名单
                </el-button>
						</div>
						<div>
							<el-button
								size="small"
								:class="'box2'"
								@click="joinCLassVisible = true"
								v-if="
									$store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
									$store.state.user.userInfo.type === $api.account.types.OTHER.value
								"
								v-permission="SP22007"
							>
								<svg-icon iconClass="add" _text="10px" _m="r-5px"></svg-icon>
								加入班级
							</el-button>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchDelete()"
								v-if="multipleSelection.length > 0"
								v-permission="SP22005"
								>批量删除</el-button
							>
						</div>
					</template>
				</div>
				<el-table
					:data="dataList"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="handleSelectionChange"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
					width="100%"
				>
					<el-table-column
						type="selection"
						width="60"
						align="center"
						v-if="$permissions([SP22006, SP22005])"
					></el-table-column>
					<el-table-column align="left" label="班级识别码" prop="id_code" />
					<el-table-column
						align="left"
						label="学校名称"
						prop="school_name"
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					/>
					<el-table-column align="left" label="班级" prop="class_name" />
					<el-table-column align="left" label="班级序号" prop="seq" />
					<el-table-column align="left" label="班级人数" prop="students_count">
            <template v-slot:default="slot">
							<router-link
								:to="{
									name: 'classView',
									query: {
                    id: slot.row.id
                  }
								}"
							>
								<el-link type="success">{{ slot.row.students_count }}</el-link>
							</router-link>
						</template>
          </el-table-column>
					<el-table-column
						align="left"
						label="辖区"
						prop="district_division"
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					>
						<template slot-scope="scope">
							{{ scope.row.school?.district_division?.l1_name }}/{{ scope.row.school?.district_division?.l2_name }}{{
								scope.row?.school?.district_division?.l3_name ? '/' + scope.row?.school?.district_division?.l3_name : ''
							}}</template
						>
					</el-table-column>
					<el-table-column
						align="left"
						v-if="$store.state.user.userInfo.type !== $api.account.types.TEACHER.value"
						label="任课老师"
						prop="school_code"
					>
						<template v-slot:default="slot">
							<template v-for="(class_grade_teachers, index) in slot.row?.class_grade_teachers">
								<svg
									:key="index"
									class="icon"
									aria-hidden="true"
									style="width: 23px; height: 23px; outline: none; box-shadow: none;"
								>
									<use
										v-if="class_grade_teachers?.subject?.name === '音乐'"
										xlink:href="#icon-music2"
										style="color: #0681c5;"
									></use>
									<use
										v-if="class_grade_teachers?.subject?.name === '美术'"
										xlink:href="#icon-arts"
										style="color: #00ad6b;"
									></use>
								</svg>
								&nbsp;{{ class_grade_teachers?.teacher?.account?.realname }}&nbsp;&nbsp;&nbsp;&nbsp;
							</template>
						</template>
					</el-table-column>
					<el-table-column align="left" label="入学年份" prop="enroll_year" />
					<el-table-column align="left" label="班级状态" prop="state" :formatter="classStatus_formatter" />
					<template v-if="$permissions([SP22003, SP22004, 'SP22007'])">
						<el-table-column align="center" label="操作" class-name="opscol" width="220">
							<template v-slot:default="slot">
								<div class="table-mgn" _flex="!~ justify-center" style="width: 100%;">
									<el-tooltip placement="top" effect="light" v-permission="'SP22007'">
										<div slot="content">查看</div>
										<div
											style="background: white;"
											_border="1px solid [#ebeef5]"
											@click="
												$router.push({
													name: `classView`,
													query: {
														id: slot.row.id
													}
												})
											"
										>
											<i class="el-icon-view" style="color: #ff7143;"></i>
										</div>
									</el-tooltip>

									<div style="color: #3f6af7;" @click="Editbutton(slot.row.id)" v-permission="SP22003">
										<el-tooltip content="编辑" placement="bottom" effect="light">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconoutlinesetting"></use>
											</svg>
										</el-tooltip>
									</div>

									<div
										class="icon delete icon-circle"
										@click="promptRemove(slot.row.id)"
										style="color: #f13048;"
										v-permission="SP22004"
									>
										<el-tooltip content="删除" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none;"
											>
												<use xlink:href="#icon-deltred"></use>
											</svg>
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="pageSize"
						:total="totalItems"
						:current-page.sync="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px;"
					>
					</el-pagination>
				</div>
			</section>
		</div>

		<el-dialog
			class="practice-sheet-new-edit-dialog"
			:width="dialogTitleType === '关联教师' ? '400px' : '540px'"
			:close-on-click-modal="false"
			:visible.sync="practiceSheetNewEditDialog"
			@close="practiceSheetNewEditDialogClose"
		>
			<div class="dialog-title2" slot="title">
				<span>{{ dialogTitleType }}</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form :model="model" ref="newForm" :rules="vaRules" @submit.native.prevent="confirm">
					<el-form-item
						prop="name"
						v-if="
							($store.state.user.userInfo.type == $api.account.types.PLATFORM_ADMIN.value ||
								$store.state.user.userInfo.type == $api.account.types.OTHER.value) &&
							(dialogTitleType === '新建班级' || dialogTitleType === '编辑班级')
						"
					>
            <InputTopTip v-model="model.name" placeholder="学校名称">
              <el-autocomplete
                placeholder=""
                v-model="model.name"
                style="width: 100%;"
                size="medium"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                @select="handleSelect"
                ref="myAutocomplete"
              >
                <template slot-scope="{ item }">
                  {{ item.value }}---------<span class="addr">{{ item.address }}</span>
                </template>
              </el-autocomplete>
            </InputTopTip>
					</el-form-item>

					<el-form-item
						v-if="dialogTitleType === '新建班级' || dialogTitleType === '编辑班级'"
						style="margin-top: 25px;"
					>
						<div :class="arereid === 2 ? 'arere' : ''">
              <InputTopTip v-model="newselectedOptions" :placeholder="'辖区'"
                v-if="
                  $store.state.user.userInfo.type == $api.account.types.PLATFORM_ADMIN.value ||
                  $store.state.user.userInfo.type == $api.account.types.OTHER.value
                "
              >
                <el-cascader
                  ref="areaRef"
                  v-model="newselectedOptions"
                  style="width: 100%;"
                  size="medium"
                  :disabled="true"
                  placeholder=""
                  :options="options"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'child',
                    emitPath: false
                  }"
                  @change="handleChange2($event)"
                />
              </InputTopTip>
						</div>
					</el-form-item>

					<el-form-item
						prop="period"
						style="margin-top: 25px;"
						v-if="dialogTitleType === '新建班级' || dialogTitleType === '编辑班级'"
					>
            <InputTopTip v-model="model.period" placeholder="学段">
              <el-select v-model="model.period" style="width: 100%;" placeholder="" size="small">
                <el-option v-for="item in bureauList" :key="item.val" :label="item.name" :value="item.val"></el-option>
              </el-select>
            </InputTopTip>
					</el-form-item>
					<el-form-item prop="musicteacher" v-if="dialogTitleType === '关联教师'">
            <InputTopTip v-model="model.musicteacher" placeholder="音乐老师">
              <el-select
                clearable
                v-model="model.musicteacher"
                placeholder=""
                size="medium"
                style="width: 100%;"
                @change="musichandlet"
                filterable
              >
                <el-option v-for="item in withTeacherList[0]" :key="item.value" :label="item.label" :value="item.value">{{
                  item.label + ' --------- ' + item.school
                }}</el-option>
              </el-select>
            </InputTopTip>
					</el-form-item>
					<el-form-item prop="artteacher" style="margin-top: 25px;" v-if="dialogTitleType === '关联教师'">
            <InputTopTip v-model="model.artteacher" placeholder="美术老师">
              <el-select
                clearable
                v-model="model.artteacher"
                placeholder=""
                size="medium"
                style="width: 100%;"
                @change="arthandle"
              >
                <el-option
                  v-for="item in withTeacherList[1]"
                  filterable
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >{{ item.label + ' --------- ' + item.school }}</el-option
                >
              </el-select>
            </InputTopTip>
					</el-form-item>

					<el-form-item
						prop="checkList1"
						style="margin-top: 15px; margin-left: 5px;"
						v-if="(dialogTitleType === '新建班级' || dialogTitleType === '编辑班级') && model.period"
					>
						<span class="schoolNianji">{{
							$store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value &&
							dialogTitleType === '编辑班级'
								? '当前年级'
								: '请选择班级目前处于的年级'
						}}</span>
						<div style="display: flex; justify-content: left; align-items: left; height: 50px;">
							<el-radio-group
								v-model="checkList1"
								style="margin-left: 2px;"
								v-if="model.period === 1"
								@change="radiohandle"
							>
								<el-radio v-for="item in primarySchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
							<el-radio-group
								v-model="checkList1"
								style="margin-left: 2px;"
								v-else-if="model.period === 2"
								@change="radiohandle"
							>
								<el-radio v-for="item in middleSchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
							<el-radio-group
								v-model="checkList1"
								style="margin-left: 2px;"
								v-else-if="model.period === 3"
								@change="radiohandle"
							>
								<el-radio v-for="item in highSchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
							<el-radio-group v-model="checkList1" style="margin-left: 2px;" v-else @change="radiohandle">
								<el-radio v-for="item in primarySchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>

					<el-form-item
						prop="checkList"
						style="margin-top: 15px; margin-left: 5px;"
						v-if="dialogTitleType === '新建班级'"
					>
						<div class="schollAxie">
							<span class="schollApex" style="width: 70px;">班级序号</span>
							<el-checkbox
								:indeterminate="isIndeterminate"
								v-model="checkAll"
								@change="handleCheckAllChange"
								style="margin-right: 25px;"
								>全选</el-checkbox
							>
						</div>
						<div style="display: flex; justify-content: left; align-items: left; height: 80px; overflow: auto;">
							<el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
								<el-checkbox v-for="city in cities" :label="city" :key="city" :disabled="disabledSeq.includes(city)" class="ClassChekbox">{{
									city
								}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-form-item>

					<el-form-item
						prop="checkList"
						style="margin-top: 15px; margin-left: 5px;"
						v-if="dialogTitleType === '编辑班级'"
					>
						<div class="schollAxie">
							<span class="schollApex" style="width: 70px;">班级序号</span>
						</div>
						<div style="display: flex; justify-content: left; align-items: left; height: 80px; overflow: auto;">
							<el-checkbox-group v-model="checkList" @change="singleChoice">
								<el-checkbox v-for="city in cities" :label="city" :key="city" :disabled="disabledSeq.includes(city)" class="ClassChekbox">{{
									city
								}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-form-item>

					<div style="margin-top: 25px;">
						<el-divider></el-divider>
					</div>
					<el-form-item
						style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;"
					>
						<el-button
							class="btn-close"
							@click="practiceSheetNewEditDialogClose"
							style="width: 80px; height: 32px; line-height: 1px;"
							>取 消</el-button
						>
						<el-button
							class="btn-prim"
							type="primary"
							native-type="submit"
							style="width: 80px; height: 32px; line-height: 1px;"
							>{{ onTitleType }}</el-button
						>
					</el-form-item>
				</el-form>
			</template>
		</el-dialog>
		<!-- 批量导入 -->
		<batch-import-account ref="importDialog" :target="'classroom'" />

		<el-dialog
			class="practice-sheet-new-edit-dialog"
			:width="'540px'"
			:close-on-click-modal="false"
			:visible="joinCLassVisible"
			@close="joinCLassVisible = false"
		>
			<div class="dialog-title2" slot="title">
				<span>加入班级</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form :model="joinClassModel" ref="newForm">
					<!-- 1.1.1教师加入班级概念 -->
					<el-form-item>
            <InputTopTip v-model="joinClassModel.code" placeholder="班级识别码">
              <el-input
                v-model="joinClassModel.code"
                class="width-264"
                placeholder=""
                size="small"
              ></el-input>
            </InputTopTip>
					</el-form-item>

					<!-- 1.0教师加入班级的概念 -->
					<!-- <el-form-item prop="period">
						<el-select
							v-model="joinClassModel.period"
							@change="joinPeriodSelcet"
							style="width: 100%;"
							placeholder="学段"
							size="small"
						>
							<el-option v-for="item in bureauList" :key="item.val" :label="item.name" :value="item.val"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="class_grades" _m="t-15px l-5px" v-if="joinClassModel.period">
						<span class="schoolNianji" _h="35px">年级</span>
						<div style="display: flex; justify-content: left; align-items: left; max-height: 50px;">
							<el-radio-group
								v-model="joinClassModel.class_grades"
								style="margin-left: 2px;"
								v-if="joinClassModel.period === 1"
								@change="getJoinClassList"
							>
								<el-radio v-for="item in primarySchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
							<el-radio-group
								v-model="joinClassModel.class_grades"
								style="margin-left: 2px;"
								v-else-if="joinClassModel.period === 2"
								@change="getJoinClassList"
							>
								<el-radio v-for="item in middleSchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
							<el-radio-group
								v-model="joinClassModel.class_grades"
								style="margin-left: 2px;"
								v-else-if="joinClassModel.period === 3"
								@change="getJoinClassList"
							>
								<el-radio v-for="item in highSchool" :key="item.val" :label="item.val" class="ClassesRadio">{{
									item.name
								}}</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>

					<el-form-item
						prop="class_ids"
						style="margin-top: 15px; margin-left: 5px;"
						v-if="joinClassModel.class_grades && isJoinClassList.length > 0"
					>
						<div class="schollAxie">
							<span class="schollApex" style="width: 70px;">班级序号</span>
							<el-checkbox
								:indeterminate="isJoinIndeterminate"
								v-model="joinCheckAll"
								@change="handleJoinCheckAllChange"
								style="margin-right: 25px;"
								>全选</el-checkbox
							>
						</div>
						<div style="display: flex; justify-content: left; align-items: left; max-height: 80px; overflow: auto;">
							<el-checkbox-group v-model="joinClassModel.class_ids" @change="handleCheckedJoinChange">
								<el-checkbox v-for="item in isJoinClassList" :label="item.id" :key="item.id" class="ClassChekbox">{{
									item?.seq
								}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-form-item>
           -->

					<!-- 沙雕产品又说不要学科了 -->
					<!-- <el-form-item prop="subject_id" style="margin-top: 15px; margin-left: 5px;">
						<span class="schollApex" style="width: 70px;">学科</span>
						<div style="display: flex; justify-content: left; align-items: left; max-height: 80px; overflow: auto;">
							<el-checkbox-group
								v-model="joinClassModel.subject_id"
								@change="$event => (joinClassModel.subject_id = $event)"
							>
								<el-checkbox
									v-for="item in teacherInfo.subjects"
									:label="item.id"
									:key="item.id"
									class="ClassChekbox"
									>{{ item.name }}</el-checkbox
								>
							</el-checkbox-group>
						</div>
					</el-form-item> -->
					<div style="margin-top: 25px;">
						<el-divider></el-divider>
					</div>
					<div _flex="~ justify-center items-center" _w="100%" _h="60px">
						<el-button
							type="primary"
							size="mini"
							native-type="submit"
							_w="150px"
							_h="30px"
							:disabled="!(joinClassModel.subject_id[0] && joinClassModel.code)"
							@click="joinClass"
							>加入班级</el-button
						>
					</div>
				</el-form>
			</template>
		</el-dialog>
	</main>
</template>
<script>
import { SP22001, SP22002, SP22003, SP22004, SP22005, SP22006, SP22007 } from '@/utils/permissionMap.js'
import BatchImportAccount from '@/components/BatchImportAccount'
import { throttle, map } from 'lodash'
import { classStatus } from './const.js'
const ErrorImg = require('@/assets/test_client/Group 682.png')
const ErrorImg2 = require('@/assets/test_client/Group 681.png')
const cityOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
const primarySchool = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' }
]
const middleSchool = [
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' }
]
const highSchool = [
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const gradesArr = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' },
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' },
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
export default {
	props: [],
	data() {
		return {
      classStatus,
			SP22001,
			SP22002,
			SP22003,
			SP22004,
			SP22005,
			SP22006,
			SP22007,
			classNumber: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
			withTeacherList: [],
			withTeacherBtnVisible: true,
			joinCheckAll: false,
			isJoinIndeterminate: false,
			isJoinClassList: [],
			joinCLassVisible: false,
			teacherInfo: {},
			joinClassModel: {
				code: '',
				class_grades: '',
				class_ids: [],
				period: '', // 学段
				// subject_id: '' // 学科
				subject_id: [] // 学科
			},
			ErrorImg,
			ErrorImg2,
			areaOptions: {},
			querylist: '省 / 市 / 区',
			selectedOptions: [], //列表省市区
			listId: null,
			refreshItem: 0,
			arereid: 1, //编辑辖区颜色id
			options: [],
			options2: [],
			options3: [],

			//新建省市区
			newareaOptions: {},
			newselectedOptions: [],
			checkList: [],
      resultCheckList: [],
			checkList1: [],
			newlistId: null,
			musiicId: null,
			artId: null,
			model: {
				name: '',
				periodTime: '',
				musicteacher: '',
				artteacher: '',
				period: null,
				Perfect: '省 / 市 / 区' //回显省市区
			},
			SearchClass: null, //搜索班级ID
			SearchGrade: null, //搜索年级ID
      fb_state: '',
			EditId: null,
			SchoolId: null,
			vaRules: {
				name: [
					{
						required: true,
						message: '未选择学校，请输入学校后下拉选择对应学校',
						trigger: 'change'
					}
				],
				period: [
					{
						required: true,
						message: '至少选择一个学段',
						trigger: 'change'
					}
				],
				periodTime: [
					{
						required: true,
						message: '请输入入学年份，如2022',
						trigger: 'change'
					}
				],
				musicteacher: [
					{
						required: false,
						message: '未选择音乐教师，请输入音乐教师名字后下拉选择对应教师',
						trigger: 'change'
					}
				],
				artteacher: [
					{
						required: false,
						message: '未选择美术教师，请输入美术教师名字后下拉选择对应教师',
						trigger: 'change'
					}
				],
				checkList1: [
					{
						validator: (rule, value, callback) => {
							if (this.checkList1.length === 0) {
								callback(new Error('年级至少勾选一个'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				],
				checkList: [
					{
						validator: (rule, value, callback) => {
              this.resultCheckList = this.checkList.filter(item => !this.disabledSeq.includes(item))
							if (this.resultCheckList.length <= 0) {
								callback(new Error('班级至少勾选一个'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				]
			},
			dialogTitleType: '', //新建||编辑
			onTitleType: '', //确定||更新
			activeTab: 'personal',
			filter_form: {
				bureauFilter: null,
				bureauFilter2: null,
				name: '',
				username: ''
			},
			bureauList: [
				{ val: 1, name: '小学' },
				{ val: 2, name: '初中' },
				{ val: 3, name: '高中' }
			],
			dataList: [],
			pageSize: 10,
			totalItems: 0,
			currentPage: 1, // 第几页
			multipleSelection: [], // 批量删除
			currentPracticeSheetObj: null,
			dialogVisible: false,
			practiceSheetNewEditDialog: false, //设置新建班级弹窗
			checkAll: false, //全选
			isIndeterminate: false, //全选
			cities: cityOptions,
			gradesArr,
			primarySchool,
			middleSchool,
			highSchool,
			restaurants: [],
			timer: null,
      disabledSeq: []
		}
	},
	components: {
		BatchImportAccount
	},
	async created() {
		/* this.getNewAreaOptions()
		this.getAreaOptions() */
		this.RegionalLevel()
		const userInfo = this.$store.state.user.userInfo
		if (userInfo.teachers?.length >= 1) {
			const teacherInfo = this.$store.state.user.userInfo?.teachers[0]
			this.teacherInfo = {
				school_name: teacherInfo.school.name,
				school_id: teacherInfo.school_id,
				subjects: teacherInfo.subjects
			}
      this.newlistId = teacherInfo.school.region_code
			this.joinClassModel.subject_id = [this.teacherInfo.subjects[0].id]
			this.teacherGradesArr = [
				...(teacherInfo.school.primary_school ? primarySchool : []),
				...(teacherInfo.school.middle_school ? middleSchool : []),
				...(teacherInfo.school.high_school ? highSchool : [])
			]
			this.bureauList = []
			teacherInfo.school.primary_school && this.bureauList.push({ val: 1, name: '小学' })
			teacherInfo.school.middle_school && this.bureauList.push({ val: 2, name: '初中' })
			teacherInfo.school.high_school && this.bureauList.push({ val: 3, name: '高中' })
		}
		// 校官回显
		if (userInfo?.school_admin?.length >= 1) {
			const schoolInfo = userInfo?.school_admin[0]
			this.newlistId = schoolInfo.school.region_code
			this.model.name = schoolInfo.school.name
			this.model.id = schoolInfo.school_id
			this.SchoolId = schoolInfo.school_id
			this.teacherGradesArr = [
				...(schoolInfo.school.primary_school ? primarySchool : []),
				...(schoolInfo.school.middle_school ? middleSchool : []),
				...(schoolInfo.school.high_school ? highSchool : [])
			]
			this.bureauList = []
			schoolInfo.school.primary_school && this.bureauList.push({ val: 1, name: '小学' })
			schoolInfo.school.middle_school && this.bureauList.push({ val: 2, name: '初中' })
			schoolInfo.school.high_school && this.bureauList.push({ val: 3, name: '高中' })
		}


		if (this.$route.query?.classlist?.district_division != undefined) {
			this.listId = this.$route.query.classlist?.district_division?.code

      /* 古人的强大处理方式，注释千古留名
			  this.querylist =
          this.$route.query.classlist?.district_division?.l1_name +
          '/' +
          this.$route.query.classlist?.district_division?.l2_name +
          '/' +
          this.$route.query.classlist?.district_division?.l3_name
      */

			this.filter_form.name = this.$route.query.classlist.name
      this.selectedOptions = Number(this.listId)
      this.refreshDataList1()
      return
		}

    try {
      const { school_name, username, grade, fb_seq, region_code, page, page_size, fb_state } = this.$store.state.searchParams[this.$route.name]
      this.filter_form.name = school_name
      this.filter_form.username = username
      this.SearchGrade = grade
      this.SearchClass = fb_seq
      this.fb_state = fb_state
      this.listId = region_code
      this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
      this.currentPage = page
      this.pageSize = page_size
      this.refreshDataList1()
    } catch(err) {
      console.log('正常~')
      this.refreshDataList1()
    }
	},

	methods: {
		async getClassNumber() {
			const data = await this.$api.classgrade.classGrdeNumber({
				grade: this.SearchGrade,
				school_id: this.SchoolId || ''
			})
			this.classNumber = data
		},
		async joinClass() {
			await this.$api.classgrade.classgradeJoin({
				code: this.joinClassModel.code
				// subject_ids: this.joinClassModel.subject_id
				// school_id: this.teacherInfo.school_id,
				// class_ids: this.joinClassModel.class_ids
			})
			this.refreshDataListBefore()
			this.joinCLassVisible = false
		},
		joinPeriodSelcet(e) {
			this.joinClassModel.class_ids = []
			this.joinClassModel.class_grades = ''
		},
		async getJoinClassList() {
			this.joinClassModel.class_ids = []
			const { data } = await this.$api.classgrade.list({
				with_all: true,
				fb_school_id: this.teacherInfo.school_id,
				grade: this.joinClassModel.class_grades,
				page: 1,
				page_size: 999
			})
			this.isJoinClassList = data
		},
		async RegionalLevel() {
			this.$api.school
				.ssxlist(0)
				.then(res => {
					this.options = this.removeEmptyItems(res)
					this.options3 = res
				})
				.catch(err => {
					throw new '获取列表报错'()
				})
		},
    removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.child?.length >= 1) {
					item.child = this.removeEmptyItems(item.child)
				} else {
					item.child = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		async querySearchAsync(queryString, cb) {
			let param = {
				name: queryString
			}
			let res = null
			res = await this.$api.school.list({
				fu_name: param.name,
				page_size: 99
				// region_code: this.newlistId
			})
			let result = res.data.map(item => {
				return {
					value: item.name,
					id: item.id,
					address: item?.district_division?.l1_name + item?.district_division?.l2_name + (item?.district_division?.l3_name || ''),
					addressInputValue:
						item?.district_division?.l1_name +
						' / ' +
						item?.district_division?.l2_name +
						(item?.district_division?.l3_name ? ' / ' + item?.district_division?.l3_name : ''),
					addressId: [item?.district_division?.l1_id, item?.district_division?.l2_id, item?.district_division?.l3_id],
					middle_school: item.middle_school,
					high_school: item.high_school,
					primary_school: item.primary_school
				}
			})
			if (this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(() => {
				cb(result)
			}, 300)
		},
		handleSelect(item) {
			this.model.Perfect = item.addressInputValue
			this.model.id = item.id
			this.SchoolId = item.id
			this.$refs['myAutocomplete'].activated = false
			// 省市区回显~傻逼逻辑~傻逼
			this.newselectedOptions = item.addressId
			this.$refs['areaRef'].inputValue = this.model.Perfect
			this.newlistId = item.addressId[2]
			// 学段回显~傻逼逻辑~傻逼
			this.bureauList = []
			item.primary_school && this.bureauList.push({ val: 1, name: '小学' })
			item.middle_school && this.bureauList.push({ val: 2, name: '初中' })
			item.high_school && this.bureauList.push({ val: 3, name: '高中' })
			this.model.period = this.bureauList[0].val
      this.checkList1 = []
      this.checkList = []
      this.disabledSeq = []
		},
		musichandlet(item) {
			// this.musiicId = item.id
			this.musiicId = item
		},
		arthandle(item) {
			// this.artId = item.id
			this.artId = item
		},
		async getWithTeacherList(id) {
      try {
        let res = null
        res = await this.$api.teacher.list({
          name: '',
          subject_id: id,
          fb_school_id: this.multipleSelection[0].school_id,
          page_size: 999
        })
        let result = res.data.map(item => {
          return {
            value: item.id,
            label: item.account?.realname,
            address:
              item.school?.district_division?.l1_name +
              item.school?.district_division?.l2_name +
              (item.school?.district_division?.l3_name || ''),
            school: item.school.name
          }
        })
        this.withTeacherList.push(result)
      } catch(err) {
        console.log(err, '===')
      }
			// console.log(this.withTeacherList, '+++++')
		},
		async querySearchAsync2(queryString, cb, id) {
			let param = {
				name: queryString
			}
			let res = null

			res = await this.$api.teacher.list({
				name: param.name,
				subject_id: id,
				fb_school_id: this.SchoolId
			})

			let result = res.data.map(item => {
				return {
					value: item.account.realname,
					id: item.id,
					address:
						item.school?.district_division?.l1_name +
						item.school?.district_division?.l2_name +
						(item.school?.district_division?.l3_name || '')
				}
			})
			if (this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(() => {
				cb(result)
			}, 300)
		},
		async radiohandle(id) {
      // 已经加入的班级需要回显、禁用勾选项
      this.checkList = []
      const { data, meta } = await this.$api.classgrade.list({
        with_all: true,
        school_name: this.model.name,
        region_code: this.newlistId,
        grade: id,
        page: 1,
        page_size: 998
      })
      if (meta.total >= 1) {
        this.disabledSeq = data.map(item => item.seq)
        this.checkList = [...this.disabledSeq]
      } else {
        this.disabledSeq = []
      }
    },
		//全选
		handleCheckAllChange(val) {
			this.checkList = val ? cityOptions : this.disabledSeq
			this.isIndeterminate = false
		},
		handleJoinCheckAllChange(val) {
			this.joinClassModel.class_ids = val ? map(this.isJoinClassList, 'id') : []
			this.isJoinIndeterminate = false
		},
		// 多选变单选~~
		singleChoice(value) {
			if (value.length >= 2) {
				this.checkList = [value[value.length - 1]]
			} else {
				this.checkList = value
			}
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.cities.length
			this.checkList = value
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
		},
		handleCheckedJoinChange(value) {
			let checkedCount = value.length
			this.joinCheckAll = checkedCount === this.isJoinClassList.length
			this.joinClassModel.class_ids = value
			this.isJoinIndeterminate = checkedCount > 0 && checkedCount < this.isJoinClassList.length
		},
		getAreaData(data = { deep: 0, value: 0, code: null }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getAreaOptions() {
			let _this = this
			this.areaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		getnewAreaData(data = { deep: 0, value: 0 }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getNewAreaOptions() {
			let _this = this
			this.newareaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getnewAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		//关联教师
		async RelatedReTacher() {
			try {
				let message = true
				let school_id = this.multipleSelection[0].school_id
				try {
					this.multipleSelection.forEach(item => {
						if (item.school_id == school_id) {
							this.withTeacherBtnVisible = false
						}
						if (item.school_id !== school_id && message) {
							this.$message.error('部分教师非任教班级所属学校，无法关联！')
							message = false
							this.withTeacherBtnVisible = true
							throw new Error('结果已经出现~中止循环')
						}
					})
				} catch (err) {
					console.log(err)
				}
				if (this.withTeacherBtnVisible) return
				this.practiceSheetNewEditDialog = true
				this.dialogTitleType = '关联教师'
				this.onTitleType = '关联'
				this.withTeacherList = []
				await this.getWithTeacherList(1)
				await this.getWithTeacherList(2)
			} catch (err) {
				console.warn('多选为空~')
			}
		},
		//新建班级按钮
		Newbuttont() {
			this.arereid = 1
			this.practiceSheetNewEditDialog = true
			this.dialogTitleType = '新建班级'
			this.onTitleType = '确定'
			this.options2 = this.options3
			if (
				this.$store.state.user.userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value ||
				this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value
			) {
				this.bureauList = []
				this.bureauList.push({ val: 1, name: '小学' })
				this.bureauList.push({ val: 2, name: '初中' })
				this.bureauList.push({ val: 3, name: '高中' })
			}
		},
		//编辑班级按钮
		async Editbutton(id) {
			this.arereid = 2
			this.dialogTitleType = '编辑班级'
			this.onTitleType = '更新'
			this.practiceSheetNewEditDialog = true
			this.options2 = this.options3
			this.EditId = id
			let res = null
			res = await this.$api.classgrade.editlist(id)
			if (this.dialogTitleType === '编辑班级') {
				// 编辑班级只能显示学校的学段~傻逼逻辑~看到这段代码还是跑路吧
				if (
					this.$store.state.user.userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value ||
					this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value
				) {
					const item = res.school
					this.bureauList = []
					item.primary_school && this.bureauList.push({ val: 1, name: '小学' })
					item.middle_school && this.bureauList.push({ val: 2, name: '初中' })
					item.high_school && this.bureauList.push({ val: 3, name: '高中' })
				}

				this.model.name = res.school_name
				this.checkList1 = res.grade_number
				this.model.periodTime = res.enroll_year
				if (res.grade_number <= 6) {
					this.model.period = 1
				} else if (res.grade_number > 6 && res.grade_number <= 9) {
					this.model.period = 2
				} else if (res.grade_number >= 10 && res.grade_number <= 12) {
					this.model.period = 3
				}
				this.SchoolId = res.school.id
				//eslint-disable-next-line no-unused-vars
				for (let i in res.school.district_division) {
					var arr = [] //声明一个新的数组
					arr.push({
						province: res.school?.district_division?.l1_name, //把省份保存到新的数组里
						city: res.school?.district_division?.l2_name, //把市保存到新的数组里
						county: res.school?.district_division?.l3_name //把区保存到新的数组里
					})
				}
				//进一步处理成可以回显的数据
				arr.map(item => {
					this.model.Perfect = item.province + ' / ' + item.city + ' / ' + item.county
				})
				// 编辑班级的时候需要回显班级序号
				this.checkList = [res.seq]
        this.newselectedOptions = Number(res.school.district_division.code)
        this.newlistId = this.newselectedOptions
        this.radiohandle(res.grade_number)
			}
		},
		expandleChange(list) {
			for (var i = 0; i < list?.length; i++) {
				if (list[i].child?.length < 1) {
					list[i].child = undefined
				} else {
					this.expandleChange(list[i]?.child)
				}
			}
			return list
		},

		handleChange(row) {
			const checkedNode = this.$refs['cascaderArr'].getCheckedNodes()
			this.listId = checkedNode[0].data.code
      this.currentPage = 1
      this.refreshDataList1()
		},
		//班级
		SearchClassChange(val) {
			this.SearchClass = val
			this.refreshDataListBefore()
		},
		//年级
		SearchGradeChange(val) {
			this.SearchGrade = val
			this.$set(this.filter_form, 'bureauFilter2', '')
			this.SearchClass = ''
			this.getClassNumber()
			this.refreshDataListBefore()
		},
		handleChange2(row) {
			const checkedNode = this.$refs['areaRef'].getCheckedNodes()
			this.newlistId = checkedNode[0].data.code
		},
		practiceSheetNewEditDialogClose() {
			this.currentPracticeSheetObj = null
			this.practiceSheetNewEditDialog = false
			this.EditId = null
			this.SchoolId = null
			this.$refs['newForm'].resetFields()
			this.newselectedOptions = []
			this.options2 = null
			this.checkList = []
			this.checkList1 = []
      this.disabledSeq = []
			this.newlistId = null
			;(this.musiicId = null), (this.artId = null), (this.model.name = '')
			this.model.Perfect = '省 / 市 / 区'
			this.dialogTitleType = ''
      this.isIndeterminate = false
      this.checkAll = false
			// this.bureauList = []
			// this.bureauList.push({ val: 1, name: '小学' })
			// this.bureauList.push({ val: 2, name: '初中' })
			// this.bureauList.push({ val: 3, name: '高中' })
		},

		//新建班级
		confirm: throttle(function () {
			this.$refs['newForm'].validate(async valid => {
				if (valid) {
					let idse = this.resultCheckList.map(item => item)
					if (this.onTitleType == '确定') {
						if (this.$store.state.user.userInfo.type !== this.$api.account.types.TEACHER.value) {
							if (this.model.id != null) {
								this.$api.classgrade
									.create({
										school_id: this.model.id,
										// enroll_year: this.model.periodTime,
										enroll_grade: this.checkList1,
										seq: idse
									})
									.then(cRes => {
										this.practiceSheetNewEditDialogClose()
										// this.refreshDataList2()
                    this.refreshDataList1()
									})
							} else {
								this.model.name = ''
							}
						} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
							this.$api.classgrade
								.create({
									// enroll_year: this.model.periodTime,
									enroll_grade: this.checkList1,
									seq: idse
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									// this.refreshDataList2()
                  this.refreshDataList1()
								})
						}
					} else if (this.onTitleType == '更新') {
						if (this.$store.state.user.userInfo.type !== this.$api.account.types.TEACHER.value) {
							this.$api.classgrade
								.update(this.EditId, {
									school_id: this.SchoolId,
									// enroll_year: this.model.periodTime,
									enroll_grade: this.checkList1,
									seq_num: idse[0]
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									// this.refreshDataList2()
                  this.refreshDataList1()
								})
						} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
							this.$api.classgrade
								.update(this.EditId, {
									// enroll_year: this.model.periodTime,
									school_id: this.SchoolId,
									enroll_grade: this.checkList1,
									seq_num: idse[0]
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									// this.refreshDataList2()
                  this.refreshDataList1()
								})
						}
					} else if (this.onTitleType == '关联') {
						if (this.artId == null && this.musiicId == null) {
							this.$message({
								message: '请输入至少一科教师名字后下拉选择对应教师',
								type: 'warning'
							})
						} else {
							let idse = this.multipleSelection.map(item => item.id)
							this.$api.classgrade
								.ClassConnect({
									class_ids: idse,
									teacher_ids: [this.musiicId, this.artId]
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									this.refreshDataList1()
								})
						}
					}
				} else {
					console.log('error')
				}
			})
		}, 3000),
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.currentPage = 1
			this.pageSize = val
			this.refreshDataList1()
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.refreshDataList1()
		},
		// 搜索条件时先把页码归一
		refreshDataListBefore() {
			this.currentPage = 1
			this.refreshDataList1()
		},
		async refreshDataList1() {
			let res = null
      const params = {
				with_detail: true,
				school_name: this.filter_form.name,
				username: this.filter_form.username,
				grade: this.SearchGrade,
        fb_state: this.fb_state,
				fb_seq: this.SearchClass,
				region_code: this.listId,
				page: this.currentPage,
				page_size: this.pageSize
			}
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			res = await this.$api.classgrade.list(params)
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},

		async refreshDataList2() {
			let res = null
			res = await this.$api.classgrade.list({
				with_detail: true,
				school_name: null,
				grade: null,
				fb_seq: null,
				region_code: null,
				page: this.currentPage,
				page_size: this.pageSize
			})
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},

		clearList() {
			this.filter_form.name = ''
			this.filter_form.username = ''
			this.listId = null
			this.SearchClass = null
			this.SearchGrade = null
      this.fb_state = ''
			this.selectedOptions = []
			this.filter_form.bureauFilter2 = []
			this.filter_form.bureauFilter = []
			this.querylist = '省 / 市 / 区'
			this.refreshItem++
			this.currentPage = 1
			this.refreshDataList1()
		},
		//批量删除数据
		batchDelete() {
			this.$confirm('此操作将永久删除该班级以及附属数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.id)
					this.$api.classgrade
						.ClassDeletes({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.$message.success('删除成功，请刷新数据')
								this.refreshDataListBefore()
								/* this.$message({
									message: '删除成功',
									type: 'warning'
								}) */
							}
						})
				})
				.catch(() => {})
		},
    classStatus_formatter(row) {
      return this.classStatus.find(i => i.val == row.state)?.name
    },
		promptRemove(id) {
			this.$confirm('此操作将永久删除该班级以及附属数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.classgrade.delete(id)
				this.$message.success('删除成功，请刷新数据')
				// 刷新
				this.refreshDataList1()
			})
		},
    // 下载学生名单
    async downloadClassStudent() {
      const data = await this.$api.user.httpPost('exports/students', {
        class_ids: this.multipleSelection.map(item => item.id)
      })
      window.open(data.file_path.url)
    }
	}
}
</script>
<style lang="scss" scoped>
// .arere {
// 	/deep/ .el-cascader .el-input .el-input__inner::placeholder {
// 		color: #323232;
// 	}
// }

.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}

.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 15px;
	cursor: pointer;
}
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.el-f .addr {
	font-size: 14px;
	color: #b4b4b4;
}
::-webkit-scrollbar {
	width: 4px;
}

::-webkit-scrollbar-track {
	background-color: #f3f3f3;
}

::-webkit-scrollbar-thumb {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:active {
	background-color: #aaa;
}
.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}
.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}
.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}
.el-form-item {
	margin-bottom: 1px;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
.button-img {
  /deep/ span {
    display: flex;
    align-items: center;
    justify-items: center;
  }
}
</style>
